<template>
  <div>
    <transition name="el-fade-in-linear">
      <div class="main_wrap" v-show="shown.mainshow" v-loading.fullscreen.lock="pageData.formFullscreenLoading">
        <div class="commonhead">
          <com-head class="comhead"></com-head>
        </div>
        <div class="head_wrap"></div>
        <div class="body_wrap">
          <div class="orderform_tools">
            <div class="sign_content">
              <el-button type="danger" size="small" v-if="Number(pageData.currentStatusPri) == 6"
                :disabled="Number(pageData.currentStatusPri) >= 7" @click="confirmOrder">{{
                  $t('App.page.orderform.btn_sign') }}</el-button>
              <el-row v-if="Number(pageData.currentStatusPri) >= 7">{{
                $t('App.page.orderform.span_ordercompleted')
                }}</el-row>
            </div>
          </div>
          <div style="margin-bottom: 2rem; margin-left: 10rem; width: 60rem">
            <el-alert :title="$t('App.page.orderform.notice_tips0')" type="success" :closable="false" show-icon
              effect="dark"></el-alert>
          </div>
          <div class="orderform_collapse">
            <el-collapse v-model="pageData.collapseActive" @change="handleCollapseChange">
              <el-collapse-item :title="$t('App.page.orderform.ordersstatus_title')" name="1">
                <div class="status_current">
                  <span>
                    {{ $t('App.page.orderform.span_current_body0')
                    }}<font size="3rem" color="#f56c6c">{{
                      pageData.orderform.id
                      }}</font>
                    <el-tooltip class="item" effect="dark" :content="$t('App.text.clicktocopy')" placement="bottom">
                      <el-button icon="el-icon-copy-document" type="success" circle size="mini"
                        v-clipboard:copy="pageData.orderform.id" v-clipboard:success="copySuccess"></el-button>
                    </el-tooltip>

                    {{ $t('App.page.orderform.span_current_body0')
                    }}<font size="3rem" color="#f56c6c">{{
                      pageData.orderform.cust_po
                      }}</font>
                    <el-tooltip class="item" effect="dark" :content="$t('App.text.clicktocopy')" placement="bottom">
                      <el-button icon="el-icon-copy-document" type="success" circle size="mini"
                        v-clipboard:copy="pageData.orderform.cust_po" v-clipboard:success="copySuccess"></el-button>
                    </el-tooltip>

                    {{ $t('App.page.orderform.span_current_body1')
                    }}<font size="3rem" color="#f56c6c">{{
                      pageData.orderform.fid
                      }}</font>
                    <el-tooltip class="item" effect="dark" :content="$t('App.text.clicktocopy')" placement="bottom">
                      <el-button icon="el-icon-copy-document" type="success" circle size="mini"
                        v-clipboard:copy="pageData.orderform.fid" v-clipboard:success="copySuccess"></el-button>
                    </el-tooltip>
                    {{ $t('App.page.orderform.span_current_body2')
                    }}<font color="#f56c6c" size="3rem">{{
                      this.pageData.currrntStatusName
                      }}</font>
                    {{ $t('App.page.orderform.span_time_zone')
                    }}<font color="#f56c6c" size="3rem">{{
                      $t('App.text.utc+8')
                      }}</font></span>
                </div>
                <div class="status_timeline">
                  <el-timeline>
                    <div>
                      <el-timeline-item :key="index" v-for="(status, index) in pageData.listOrderStatus" size="large"
                        :icon="status.icon" :type="status.type" :timestamp="status.timestamp" placement="top">
                        <el-card shadow="hover" class="timeline_card">
                          <span v-if="status.priority > pageData.currentStatusPri" class="timeline_item_if"><span
                              v-if="pageData.lang == 'cn'">{{
                                status.name_doing_cn
                              }}</span><span v-else>{{ status.name_doing_en }}</span>
                            <template></template>
                          </span>
                          <span v-else class="timeline_item_else">
                            <span v-if="pageData.lang == 'cn'">{{
                              status.name_done_cn
                              }}</span>
                            <span v-else>{{ status.name_done_en }}</span>
                          </span>
                        </el-card>
                      </el-timeline-item>
                    </div>
                  </el-timeline>
                </div>
              </el-collapse-item>

              <el-collapse-item :title="$t('App.page.orderform.shipping_title')" name="2">
                <div class="shipping_notice">
                  <el-tag class="el-icon-info" effect="dark" type="primary">{{
                    $t('App.page.orderform.tag_pickupself')
                    }}</el-tag>
                </div>
                <div class="shipping_content">
                  <div class="shippingcard_body">
                    <el-form label-position="right" label-width="6rem">
                      <el-form-item :label="$t('App.page.orderform.shipping_contacts')">{{ pageData.shipping.contacts
                        }}</el-form-item>
                      <el-form-item :label="$t('App.page.orderform.shipping_country')">{{ pageData.shipping.country
                        }}</el-form-item>
                      <el-form-item :label="$t('App.page.orderform.shipping_province')">{{ pageData.shipping.province
                        }}</el-form-item>
                      <el-form-item :label="$t('App.page.orderform.shipping_city')">{{ pageData.shipping.city
                        }}</el-form-item>
                      <el-form-item :label="$t('App.page.orderform.shipping_address')">{{ pageData.shipping.address
                        }}</el-form-item>
                      <el-form-item :label="$t('App.page.orderform.shipping_zipcode')">{{ pageData.shipping.zipcode
                        }}</el-form-item>
                      <el-form-item :label="$t('App.page.orderform.shipping_tel')">{{ pageData.shipping.tel
                        }}</el-form-item>
                      <el-form-item :label="$t('App.page.orderform.shipping_email')">{{ pageData.shipping.email
                        }}</el-form-item></el-form>
                  </div>
                </div>
              </el-collapse-item>

              <el-collapse-item :title="$t('App.page.orderform.receipt_title')" name="3">
                <div class="receipt_content">
                  <div class="receipt_res" v-if="
                    pageData.isImgPro &&
                    pageData.resType1 != null &&
                    pageData.orderform.proformainvoice !=
                    'data:image/jpg;base64,-' &&
                    pageData.orderform.packinglist != undefined
                  ">
                    <el-image :src="pageData.orderform.proformainvoice"
                      :preview-src-list="pageData.proformaInvoiceList">
                      <div slot="placeholder" class="image-slot">
                        {{ $t('App.text.loading') }}
                      </div>
                    </el-image>
                  </div>
                  <div class="receipt_file" v-else-if="
                    !pageData.isImgPro &&
                    pageData.resType1 != null &&
                    pageData.orderform.proformainvoice !=
                    'data:image/jpg;base64,-' &&
                    pageData.orderform.proformainvoice != undefined
                  ">
                    <el-row><i class="fa fa-circle fa-x" style="color: #f56c6c"></i>.<el-button
                        @click="downloadProforma(pageData.resType1)" size="mini" type="primary">{{
                          $t('App.view.order.text_download')
                        }}</el-button></el-row>
                    <iframe id="proformaIframe" style="display: none; margin-left: 1rem; margin-top: 1rem"
                      width="95%"></iframe>
                  </div>
                  <div class="receipt_none" v-else>
                    {{ $t('App.page.orderform.span_no_receiptimg') }}
                  </div>
                  <div v-for="(file, index) in pageData.orderFileList" :key="index" :index="index"
                    class="file_log_content">
                    <div v-if="file.prefix == '1'">
                      <div v-if="file.file_type == 'img'">
                        <i class="fa fa-circle fa-x" style="color: #f56c6c"></i>.<el-image :src="file.fileUrl"
                          style="width: 5rem" :preview-src-list="[file.fileUrl]">
                          <div slot="placeholder" class="image-slot">
                            {{ $t('App.text.loading') }}
                          </div>
                        </el-image>
                      </div>
                      <div v-else>
                        <i class="fa fa-circle fa-x" style="color: #f56c6c"></i>.<el-button
                          @click="toUtilsFile(file, 'pi_' + index)" size="mini" type="primary">{{
                            $t('App.view.order.text_download') }}</el-button>
                        <iframe :id="'pi_' + index" style="
                            display: none;
                            margin-left: 1rem;
                            margin-top: 1rem;
                            width: 50rem;
                          " width="95%"></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-item>

              <el-collapse-item :title="$t('App.page.orderform.payment_title')" name="4">
                <div class="payment_content">
                  <div class="notice_skip">
                    <el-tag class="el-icon-info" effect="dark" type="primary">{{
                      $t('App.page.orderform.tag_notice_skip_payment')
                      }}</el-tag>
                  </div>
                  <div style="text-align: left; margin-bottom: 1rem">
                    <el-button type="success" size="mini" @click="uploadBankslip" :disabled="pageData.bankslipFlag">{{
                      $t('App.view.order.btn_upload') }}</el-button>
                  </div>
                  <div class="content_upload">
                    <el-upload drag :limit="1" :show-file-list="true" accept=".png,.jpg,.pdf,.docx,.doc" action
                      :file-list="pageData.bankslipFileList" :on-change="bankslipFilter" :auto-upload="false">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        <font color="#909399">{{
                          $t('App.page.orderform.span_paymentupload_body1')
                          }}</font><em>{{
                            $t('App.page.orderform.span_paymentupload_body2')
                          }}</em>
                      </div>
                      <div class="el-upload__tip" slot="tip" style="color: #909399">
                        {{ $t('App.page.orderform.span_tip_upload') }}
                      </div>
                    </el-upload>
                  </div>
                  <div class="payment_divider"></div>
                  <div class="content_img" v-if="
                    pageData.isImgBankslip &&
                    pageData.resTypeBankslip != null &&
                    pageData.orderform.bankslip !=
                    'data:image/jpg;base64,-' &&
                    pageData.orderform.bankslip != undefined
                  ">
                    <div>
                      <el-image :src="pageData.orderform.bankslip">
                        <div slot="placeholder" class="image-slot">
                          {{ $t('App.text.loading') }}
                        </div>
                      </el-image>
                    </div>
                  </div>
                  <div class="content_file" v-else-if="
                    !pageData.isImgBankslip &&
                    pageData.resTypeBankslip != null &&
                    pageData.orderform.bankslip !=
                    'data:image/jpg;base64,-' &&
                    pageData.orderform.bankslip != undefined
                  ">
                    <el-row>Bank slip&nbsp;<el-button @click="downloadBankslip(pageData.resTypeBankslip)" size="mini"
                        type="primary">{{ $t('App.view.order.text_download') }}</el-button></el-row>
                    <iframe id="bankslipIframe" style="
                        display: none;
                        margin-left: 1rem;
                        margin-top: 1rem;
                        width: 60rem;
                      " width="95%"></iframe>
                  </div>
                </div>
              </el-collapse-item>

              <el-collapse-item :title="$t('App.page.orderform.other_title')" name="5">
                <div class="shippingdocument_content">
                  <div class="packinglist_content">
                    <div class="packinglist_res" v-if="
                      pageData.isImgPak &&
                      pageData.resType2 != null &&
                      pageData.orderform.packinglist !=
                      'data:image/jpg;base64,-' &&
                      pageData.orderform.packinglist != undefined
                    ">
                      <el-image :src="pageData.orderform.packinglist" :preview-src-list="pageData.packinglistList">
                        <div slot="placeholder" class="image-slot">
                          {{ $t('App.text.loading') }}
                        </div>
                      </el-image>
                      <span style="color: #909399">
                        {{
                          $t('App.page.orderform.span_img_packinglist')
                        }}</span>
                    </div>
                    <div class="packinglist_file" v-else-if="
                      !pageData.isImgPak &&
                      pageData.resType2 != null &&
                      pageData.orderform.packinglist !=
                      'data:image/jpg;base64,-' &&
                      pageData.orderform.packinglist != undefined
                    ">
                      <el-row>
                        <i class="fa fa-circle fa-x" style="color: #f56c6c"></i><el-button
                          @click="downloadPackinglist(pageData.resType2)" size="mini" type="primary">{{
                            $t('App.view.order.text_download') }}</el-button></el-row>
                      <iframe id="packingIframe" style="
                          display: none;
                          margin-left: 1rem;
                          margin-top: 1rem;
                          width: 43rem;
                        " width="95%"></iframe>
                    </div>
                    <div class="packinglist_none" v-else>
                      {{ $t('App.page.orderform.span_no_packinglist') }}
                    </div>
                    <div v-for="(file, index) in pageData.orderFileList" :key="index" :index="index"
                      class="file_log_content">
                      <div v-if="file.prefix == '3'">
                        <div v-if="file.file_type == 'img'">
                          <i class="fa fa-circle fa-x" style="color: #f56c6c"></i>.<el-image :src="file.fileUrl"
                            style="width: 5rem" :preview-src-list="[file.fileUrl]">
                            <div slot="placeholder" class="image-slot">
                              {{ $t('App.text.loading') }}
                            </div>
                          </el-image>
                        </div>
                        <div v-else>
                          <i class="fa fa-circle fa-x" style="color: #f56c6c"></i>.<el-button
                            @click="toUtilsFile(file, 'pl_' + index)" size="mini" type="primary">{{
                              $t('App.view.order.text_download')
                            }}</el-button>
                          <iframe :id="'pl_' + index" style="
                              display: none;
                              margin-left: 1rem;
                              margin-top: 1rem;
                              width: 50rem;
                            " width="95%"></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="shippingdocument_divider">
                    <el-divider direction="vertical"></el-divider>
                  </div>
                  <div class="commercialinvoice_content">
                    <div class="commercialinvoice_res" v-if="
                      pageData.isImgCom &&
                      pageData.resType3 != null &&
                      pageData.orderform.cominvoice !=
                      'data:image/jpg;base64,-' &&
                      pageData.orderform.cominvoice != undefined
                    ">
                      <el-image :src="pageData.orderform.cominvoice" :preview-src-list="pageData.cominvoiceList">
                        <div slot="placeholder" class="image-slot">
                          {{ $t('App.text.loading') }}
                        </div>
                      </el-image>
                      <span style="color: #909399">{{
                        $t('App.page.orderform.span_img_cominvoice')
                        }}</span>
                    </div>
                    <div class="commercialinvoice_file" v-else-if="
                      !pageData.isImgCom &&
                      pageData.resType3 != null &&
                      pageData.orderform.cominvoice !=
                      'data:image/jpg;base64,-' &&
                      pageData.orderform.cominvoice != undefined
                    ">
                      <el-row>
                        <i class="fa fa-circle fa-x" style="color: #f56c6c"></i><el-button
                          @click="downloadCominvoice(pageData.resType3)" size="mini" type="primary">{{
                            $t('App.view.order.text_download') }}</el-button></el-row>
                      <iframe id="cominvoiceIframe" style="
                          display: none;
                          margin-left: 1rem;
                          margin-top: 1rem;
                          width: 43rem;
                        " width="90%"></iframe>
                    </div>
                    <div class="commercialinvoice_none" v-else>
                      {{ $t('App.page.orderform.span_no_commercialinvoice') }}
                    </div>
                    <div v-for="(file, index) in pageData.orderFileList" :key="index" :index="index"
                      class="file_log_content">
                      <div v-if="file.prefix == '4'">
                        <div v-if="file.file_type == 'img'">
                          <i class="fa fa-circle fa-x" style="color: #f56c6c"></i>.
                          <el-image :src="file.fileUrl" style="width: 5rem" :preview-src-list="[file.fileUrl]">
                            <div slot="placeholder" class="image-slot">
                              {{ $t('App.text.loading') }}
                            </div>
                          </el-image>
                        </div>
                        <div v-else>
                          <i class="fa fa-circle fa-x" style="color: #f56c6c"></i>.<el-button
                            @click="toUtilsFile(file, 'ci_' + index)" size="mini" type="primary">{{
                              $t('App.view.order.text_download')
                            }}</el-button>
                          <iframe :id="'ci_' + index" style="
                              display: none;
                              margin-left: 1rem;
                              margin-top: 1rem;
                              width: 50rem;
                            " width="95%"></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-item>

              <el-collapse-item :title="$t('App.page.orderform.details_title')" name="6">
                <div class="order_details_notice_content">
                  <el-tag class="el-icon-info" effect="dark" type="danger">{{
                    $t('App.page.orderform.tag_notice_modifydetails')
                    }}</el-tag>
                </div>
                <div class="order_details">
                  <el-card shadow="hover">
                    <div class="table_details">
                      <el-table border ref="detailsTable" tooltip-effect="dark" :header-cell-style="{
                        textAlign: 'center',
                        backgroundColor: '#f2f6fc',
                      }" :cell-style="{ textAlign: 'center' }" :data="pageData.orderDetails">
                        <el-table-column type="index"> </el-table-column>
                        <el-table-column :label="this.$t('App.page.cart.productimage')">
                          <template slot-scope="scope">
                            <!-- <el-image
                              :src="'data:image/jpg;base64,' + scope.row.img"
                              style="width: 7rem"
                            >
                              <div slot="placeholder" class="image-slot">
                                {{ $t('App.text.loading') }}
                              </div>
                            </el-image> -->
                            <el-image v-if="
                              scope.row &&
                              scope.row.imgUrl &&
                              scope.row.imgUrl.length > 0
                            " :src="formatProductImage(scope.row.imgUrl)" style="width: 7rem">
                              <div slot="placeholder" class="image-slot">
                                {{ $t('App.text.loading') }}
                              </div>
                            </el-image>
                          </template></el-table-column>

                        <el-table-column :label="this.$t('App.page.cart.productname')">
                          <template slot-scope="scope">{{
                            scope.row.product_name
                            }}</template>
                        </el-table-column>

                        <el-table-column :label="this.$t('App.page.cart.productprice')">
                          <template slot-scope="scope">{{ pageData.orderform.sign }}
                            <span>{{ scope.row.uniprice }}</span>
                          </template>
                        </el-table-column>

                        <el-table-column :label="this.$t('App.page.cart.productdiscount')" v-if="
                          pageData.orderDetails.every(
                            (item) => !item.newprice,
                          )
                        ">
                          <template slot-scope="scope">
                            {{ Number(scope.row.scount * 100).toFixed() }}%
                          </template>
                        </el-table-column>

                        <el-table-column :label="this.$t('App.page.cart.productdisprice')">
                          <template slot-scope="scope">{{ pageData.orderform.sign
                          }}{{
                              Number(
                                scope.row.subtotal / scope.row.quantity,
                              ).toFixed(2)
                            }}</template>
                        </el-table-column>

                        <!-- 优惠价 -->
                        <!-- <el-table-column
                          :label="this.$t('App.page.cart.ladderPrice')"
                          prop="ladderPrice"
                          v-if="pageData.custUserinfo.new_price"
                        >
                          <template slot-scope="scope">
                            {{ pageData.orderform.sign
                            }}{{
                              Number(
                                scope.row.subtotal / scope.row.quantity
                              ).toFixed(2)
                            }}
                          </template>
                        </el-table-column> -->

                        <el-table-column :label="this.$t('App.page.cart.productquantity')">
                          <template slot-scope="scope">
                            {{ scope.row.quantity }}
                          </template>
                        </el-table-column>

                        <el-table-column :label="this.$t('App.page.cart.productsubprice')">
                          <template slot-scope="scope">{{ pageData.orderform.sign
                          }}{{
                              Number(scope.row.subtotal).toFixed(2)
                            }}</template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <div class="field_notes">
                      {{ $t('App.page.orderconfirm.title_notes') }}:
                      <el-input type="textarea" :autosize="{ minRows: 2 }" maxlength="240" show-word-limit
                        :placeholder="$t('App.text.placeholder_notes')"
                        :disabled="Number(pageData.currentStatusPri) > 1" v-model="pageData.orderform.notes"></el-input>
                      <el-button type="success" size="mini" @click="updateNotes(pageData.orderform.notes)"
                        :disabled="Number(pageData.currentStatusPri) > 1">{{ $t('App.page.orderform.btn_done')
                        }}</el-button>
                    </div>
                  </el-card>
                </div>
                <div class="total_items">
                  <div class="total_span">
                    <span>
                      <font color="#606266">{{
                        $t('App.page.orderform.span_total')
                        }}</font><span v-if="
                          this.pageData.orderform.total === 0 ? false : true
                        ">{{ pageData.orderform.sign }}</span>{{ Number(pageData.orderform.total).toFixed(2) }}
                    </span>
                    <span>
                      <font color="#606266">{{
                        $t('App.page.orderform.span_totalWeight')
                        }}</font>
                      {{ Number(pageData.orderform.weight).toFixed(2) }}kg
                    </span>
                  </div>
                </div>
              </el-collapse-item>

              <el-collapse-item :title="$t('App.page.orderform.list_title')" name="7"
                v-if="pageData.listDeliveryDisplay.length != 0">
                <div class="ad_notice_content">
                  <el-tag class="el-icon-info" effect="dark" type="success" size="medium">{{
                    $t('App.notify.notice_auto_logist_err')
                    }}</el-tag>
                </div>
                <div class="batchlist_content">
                  <el-collapse :value="pageData.batchCollapseAct">
                    <el-collapse-item v-for="(delivery, index) in pageData.listDeliveryDisplay" :key="index"
                      :index="index" :name="index" :title="$t('App.page.orderform.text_logistics_no') +
                        delivery.logistics_no +
                        '   ' +
                        $t('App.page.orderform.text_time') +
                        delivery.create_time
                        ">
                      <div class="batch_table">
                        <el-row class="batch_title">{{
                          $t('App.page.orderform.title_batchtable')
                          }}</el-row>
                        <el-table border stripe :data="delivery.products" :header-cell-style="{
                          textAlign: 'center',
                          backgroundColor: '#f2f6fc',
                        }" :cell-style="{ textAlign: 'center' }">
                          <el-table-column type="index"> </el-table-column>
                          <el-table-column :label="$t('App.view.order.label_table_prodname')">
                            <template slot-scope="scope">
                              {{ scope.row.product_name }}
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('App.view.order.label_table_prodquantity')
                            ">
                            <template slot-scope="scope">
                              {{ scope.row.quantity }}
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                      <div class="batch_tracking">
                        <div class="tracking_top">
                          <el-row class="batch_company_title">{{ $t('App.view.order.text_logistics_company')
                          }}{{ delivery.logistics_company }}</el-row>
                          <el-row class="batch_title">{{
                            $t('App.page.orderform.title_tracking')
                            }}</el-row>
                          <el-button size="mini" type="success" @click="getTracking(index)">{{
                            $t('App.page.orderform.btn_postapi')
                          }}</el-button>
                          <div class="ad_notice_content">
                            <el-tag class="el-icon-info" effect="dark" type="primary" size="small">{{
                              $t('App.page.orderform.tag_ad_notice')
                            }}</el-tag>
                          </div>
                        </div>
                        <div v-if="!pageData.trackingFlag" style="color: #f56c6c; font-size: 0.9rem">
                          {{ $t('App.page.orderform.text_track_tip') }}
                        </div>
                        <div :id="'trackingContainer' + index" style="margin-top: 1rem"></div>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div class="foot_wrap">
          <com-foot></com-foot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import Head from '@/components/customer/customerCommonHeader'
import Foot from '@/components/customer/customerCommonFooter'
import * as orderformjs from '@/assets/js/orderform'
import * as verifyjs from '@/assets/js/verify'
import * as utilsjs from '@/assets/js/utils'
export default {
  data() {
    return {
      api: '',
      shown: {
        mainshow: false,
      },
      pageData: {
        username: '',
        lang: '',
        statusId: '',
        formFullscreenLoading: true,
        proformaInvoiceList: [],
        packinglistList: [],
        cominvoiceList: [],
        orderid: '',
        collapseActive: ['1', '2', '3', '4', '5', '6', '7'],
        listCountry: [],
        orderform: {},
        orderDetails: [],
        listOrderStatus: [],
        listOrderRecords: [],
        currentStatusPri: 0,
        currrntStatusName: '',
        shipping: {},
        count: 0,
        bankslipFlag: true,
        bankslipFileList: [],
        listDeliveryCurrent: [],
        listDeliveryDisplay: [],
        batchCollapseAct: '',
        isImgPro: false,
        isImgPak: false,
        isImgCom: false,
        isImgBankslip: false,
        resType1: '',
        resType2: '',
        resType3: '',
        resTypeBankslip: '',
        fileTypeBankslip: '',
        trackingFlag: false,
        orderFileList: [],
      },
      formData: {},
    }
  },
  created() {
    this.$npg.start()
    this.$npg.inc()
  },
  mounted() {
    this.prepareForMounted()
  },
  methods: {
    prepareForMounted() {
      this.$npg.done()
      this.pageData.username = sessionStorage.getItem('username')
      this.pageData.lang = sessionStorage.getItem('lang')
      this.pageData.custUserinfo = JSON.parse(
        sessionStorage.getItem(this.pageData.username),
      )
      if (verifyjs.isMounted(this)) {
        document.title = this.$t('App.title.orderform')
        this.pageData.orderid = this.$route.query.orderid
        if (
          typeof this.pageData.orderid == undefined ||
          this.pageData.orderid == null ||
          this.pageData.orderid == ''
        ) {
          this.$router.push({ name: 'Home' })
        } else {
          this.pageData.count = this.pageData.custUserinfo.discount
          this.pageData.listCountry = JSON.parse(
            sessionStorage.getItem('listCountry'),
          )

          this.importTrackJs()

          orderformjs.getOrderform(
            this,
            this.pageData.orderid,
            this.pageData.username,
          )

          setTimeout(() => {
            this.shown.mainshow = true
          }, 1)
        }
      } else {
        this.$router.push({ name: 'Login' })
      }
    },

    formatProductImage(img) {
      if (!img || img.length === 0) return ''
      // If already base64 or full URL, return as is
      if (img.indexOf('data:image') === 0 || img.indexOf('http') === 0) {
        return img
      }
      // If starts with /images, prepend the product image server URL
      if (img.indexOf('/images') === 0) {
        return (process.env.PRODUCT_IMAGE_URL || '') + img
      }
      // Otherwise, prepend API prefix
      return (this.api || '') + img
    },
    importTrackJs() {
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = '//www.17track.net/externalcall.js'
      document.head.appendChild(script)
    },
    getTracking(index) {
      if (
        !verifyjs.strIsEmpty(
          this.pageData.listDeliveryCurrent[index].logistics_no,
        )
      ) {
        YQV5.trackSingle({
          YQ_ContainerId: 'trackingContainer' + index,
          YQ_Height: 560,
          YQ_Fc: '0',
          YQ_Lang: 'en',
          YQ_Num: this.pageData.listDeliveryCurrent[index].logistics_no,
        })
      }
      this.pageData.trackingFlag = true
    },
    downloadProforma(type) {
      let frame = document.getElementById('proformaIframe')
      if (type == 'docx' || type == 'doc') {
        // frame.src = this.pageData.orderform.proformainvoice
        frame.src = this.pageData.orderform.proformainvoiceUrl
      } else if (type == 'pdf') {
        // frame.src = this.pageData.orderform.proformainvoice
        frame.src = this.pageData.orderform.proformainvoiceUrl
        frame.style.display = 'block'
        frame.style.height = '50rem'
      }
    },
    downloadBankslip(type) {
      console.log(type, 123)
      let frame = document.getElementById('bankslipIframe')
      if (type == 'docx' || type == 'doc') {
        // frame.src = this.pageData.orderform.bankslip
        frame.src = this.pageData.orderform.bankslipUrl
      } else if (type == 'pdf') {
        // frame.src = this.pageData.orderform.bankslip
        frame.src = this.pageData.orderform.bankslipUrl
        frame.style.display = 'block'
        frame.style.height = '50rem'
      }
    },
    downloadPackinglist(type) {
      let frame = document.getElementById('packingIframe')
      if (type == 'docx' || type == 'doc') {
        // frame.src = this.pageData.orderform.packinglist
        frame.src = this.pageData.orderform.packinglistUrl
      } else if (type == 'pdf') {
        // frame.src = this.pageData.orderform.packinglist
        frame.src = this.pageData.orderform.packinglistUrl
        frame.style.display = 'block'
        frame.style.height = '60rem'
      }
    },
    downloadCominvoice(type) {
      let frame = document.getElementById('cominvoiceIframe')
      if (type == 'docx' || type == 'doc') {
        // frame.src = this.pageData.orderform.cominvoice
        frame.src = this.pageData.orderform.cominvoiceUrl
      } else if (type == 'pdf') {
        // frame.src = this.pageData.orderform.cominvoice
        frame.src = this.pageData.orderform.cominvoiceUrl
        frame.style.display = 'block'
        frame.style.height = '60rem'
      }
    },
    handleCollapseChange(val) { },
    confirmOrder() {
      if (Number(this.pageData.currentStatusPri) != 6) {
        return
      }

      let confirmOrder = {}
      confirmOrder.id = this.pageData.orderid
      confirmOrder.username = this.pageData.username
      confirmOrder.orderstatus_id = this.pageData.statusId

      this.$axios({
        method: 'post',
        // url: Vue.prototype.api + '6003/api/local/confirmOrder',
        url: Vue.prototype.api + 'api/local/confirmOrder',
        data: confirmOrder,
      })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.code == '200') {
              this.$notify.success({
                title: this.$t('App.notify.title_success'),
                message: this.$t(
                  'App.page.orderform.notify_confirmorder_success',
                ),
              })
            } else if (response.data.code == '210') {
              this.$notify.error({
                title: this.$t('App.notify.title_server'),
                message: this.$t('App.notify.content_servererr'),
              })
              return
            } else if (response.data.code == '290') {
              this.$notify.error({
                title: this.$t('App.notify.title_server'),
                message: this.$t('App.notify.notify_repeat_confirm'),
              })
              return
            } else if (response.data.code == '600') {
              this.$router.push({
                name: 'Login',
              })
            } else {
              this.$notify.error({
                title: this.$t('App.notify.title_server'),
                message: this.$t('App.notify.content_servererr'),
              })
              return
            }
          } else {
            this.$notify.error({
              title: this.$t('App.notify.title_server'),
              message: this.$t('App.notify.content_server') + response.status,
            })
            return
          }
        })
        .catch((error) => {
          this.$notify.error({
            title: this.$t('App.notify.title_server'),
            message: this.$t('App.notify.content_servererr'),
          })
          return
        })
    },
    updateNotes(notes) {
      if (verifyjs.strIsEmpty(notes)) {
        return
      }

      let order = {}
      order.id = this.pageData.orderid
      order.notes = notes

      this.$axios({
        method: 'post',
        // url: Vue.prototype.api + '6003/api/local/updateOrderNotes',
        url: Vue.prototype.api + 'api/local/updateOrderNotes',
        data: order,
      })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.code == '200') {
              this.$notify.success({
                title: this.$t('App.notify.title_success'),
                message: this.$t('App.page.orderform.notify_notessuccess'),
              })
              return
            } else {
              this.$notify.error({
                title: this.$t('App.notify.title_server'),
                message: this.$t('App.notify.content_servererr'),
              })
              return
            }
          } else {
            this.$notify.error({
              title: this.$t('App.notify.title_server'),
              message: this.$t('App.notify.content_server') + response.status,
            })
            return
          }
        })
        .catch((error) => {
          this.$notify.error({
            title: this.$t('App.notify.title_server'),
            message: this.$t('App.notify.content_servererr'),
          })
          return
        })
    },
    bankslipFilter(file, fileList) {
      let fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (!utilsjs.pictureFilter(this, file)) {
        this.pageData.bankslipFileList = []
      } else {
        if (
          fileSuffix == 'pdf' ||
          fileSuffix == 'docx' ||
          fileSuffix == 'doc'
        ) {
          let reader = new FileReader()
          reader.readAsDataURL(file.raw)
          reader.onload = (e) => {
            this.pageData.orderform.bankslip = reader.result
          }

          this.pageData.isImgBankslip = false
          this.pageData.fileTypeBankslip = fileSuffix
          this.pageData.bankslipFlag = false
        } else {
          let reader = new FileReader()
          reader.readAsDataURL(file.raw)
          reader.onload = (e) => {
            this.pageData.orderform.bankslip = reader.result
            this.pageData.bankslipFlag = false
            this.pageData.isImgBankslip = true
            this.pageData.fileTypeBankslip = fileSuffix
          }

        }
      }
    },
    uploadBankslip() {
      let order = {}
      order.id = this.pageData.orderid
      order.bankslip = this.pageData.orderform.bankslip
      order.fileType = this.pageData.fileTypeBankslip

      this.$axios({
        method: 'post',
        // url: Vue.prototype.api + '6003/api/local/uploadBankSlip',
        url: Vue.prototype.api + 'api/local/uploadBankSlip',
        data: order,
      })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.code == '200') {
              let frame = document.getElementById('bankslipIframe')
              if (frame != null) {
                frame.style.display = 'none'
              }
              this.$notify.success({
                title: this.$t('App.notify.title_success'),
                message: this.$t('App.page.orderform.notify_upload_success'),
              })
              this.pageData.bankslipFlag = true
              return
            } else {
              this.$notify.error({
                title: this.$t('App.notify.title_server'),
                message: this.$t('App.notify.content_servererr'),
              })
              return
            }
          } else {
            this.$notify.error({
              title: this.$t('App.notify.title_server'),
              message: this.$t('App.notify.content_server') + response.status,
            })
            return
          }
        })
        .catch((error) => {
          this.$notify.error({
            title: this.$t('App.notify.title_server'),
            message: this.$t('App.notify.content_servererr'),
          })
          return
        })
    },
    toUtilsFile(file, id) {
      utilsjs.previewFile(file, id)
    },
    copySuccess(e) {
      this.$message({
        type: 'success',
        message: this.$t('App.text.copy_success'),
      })
    },
  },
  components: {
    'com-head': Head,
    'com-foot': Foot,
  },
}
</script>

<style scoped>
.main_wrap {
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  position: fixed;
  overflow-x: auto;
}

/* .comhead {
  position: fixed;
  z-index: 999;
} */
.body_wrap {
  margin-top: 8rem;
}

.orderform_tools {
  margin-bottom: 1rem;
}

.sign_content {
  text-align: left;
  margin-left: 10rem;
}

.sign_content .el-row {
  color: #67c23a;
  font-size: 0.9rem;
  margin-top: 1rem;
}

.status_current {
  text-align: left;
  margin-bottom: 1rem;
  color: #606266;
  font-size: 0.9rem;
}

.status_timeline {
  margin-left: 0;
}

.status_timeline .el-timeline {
  text-align: left;
}

.timeline_card {
  width: 30rem;
}

.timeline_item_if {
  color: #606266;
  font-weight: 500;
}

.timeline_item_else {
  color: #67c23a;
  font-weight: 500;
}

.orderform_collapse {
  width: 100rem;
  margin-left: 10rem;
}

.shipping_notice {
  text-align: left;

  margin-top: 1rem;
}

.shipping_notice .el-tag {
  font-size: 0.9rem;
}

.shipping_content {
  padding: 0.5rem;
  text-align: left;
  color: #606266;
  font-size: 0.9rem;
  line-height: 2rem;

  overflow: auto;
}

.receipt_content {
  overflow: auto;
}

.shippingcard_body {
  overflow: auto;
}

.shippingcard_body .el-form-item {
  margin-bottom: 0;
  color: #909399;
}

.notice_skip {
  text-align: left;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.notice_skip .el-tag {
  font-size: 0.9rem;
}

.order_details_notice_content {
  text-align: left;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.order_details_notice_content .el-tag {
  font-size: 0.9rem;
}

.order_details {
  margin: 0 auto;
  width: 100rem;
  overflow: auto;
}

.field_notes {
  margin-top: 1rem;
  text-align: left;
  color: #606266;
  font-size: 0.9rem;
}

.field_notes .el-button {
  margin-top: 1rem;
}

.total_span {
  text-align: right;
  /* margin-right: 10rem; */
  margin-top: 0.8rem;
  color: #f56c6c;
  font-size: 1.2rem;
}

.receipt_res {
  text-align: left;
  width: 20rem;
}

.receipt_none {
  text-align: left;
  color: #f56c6c;
  font-size: 0.9rem;
  padding: 1rem;
}

.payment_content {
  overflow: auto;
}

.content_upload {
  display: table-cell;
  text-align: center;
}

.payment_divider {
  display: table-cell;
  width: 10rem;
}

.content_img {
  display: table-cell;
  width: 20rem;
}

.packinglist_content,
.commercialinvoice_content {
  display: table-cell;
  width: 40vh;
}

.shippingdocument_divider {
  display: table-cell;
  width: 15rem;
}

.shippingdocument_divider .el-divider {
  height: 10vh;
}

.shippingdocument_content {
  overflow: auto;
}

.packinglist_res {
  text-align: center;
  width: 20rem;
}

.commercialinvoice_res {
  text-align: center;
  width: 20rem;
}

.packinglist_none {
  text-align: left;
  color: #f56c6c;
  font-size: 0.9rem;
  padding: 1rem;
}

.commercialinvoice_none {
  text-align: left;
  color: #f56c6c;
  font-size: 0.9rem;
  padding: 1rem;
}

.batchlist_content {
  overflow: auto;
  padding: 2rem;
  width: 100%;
}

.receipt_file {
  text-align: left;
  margin-left: 2rem;
  padding: 0.2rem;
}

.receipt_file .el-row {
  color: #409eff;
  /* font-size: 0.9rem; */
}

.packinglist_file {
  text-align: left;
  margin-left: 2rem;
  padding: 0.2rem;
}

.packinglist_file .el-row {
  color: #409eff;
  /* font-size: 0.9rem; */
}

.commercialinvoice_file {
  text-align: left;
  margin-left: 2rem;
  padding: 0.2rem;
}

.commercialinvoice_file .el-row {
  color: #409eff;
  /* font-size: 0.9rem; */
}

.batch_table .el-table {
  margin-bottom: 1rem;
}

.batch_company_title {
  text-align: left;
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: bold;
  color: #f56c6c;
}

.batch_title {
  text-align: left;
  margin-bottom: 1rem;
  font-size: 1rem;
  color: #f56c6c;
}

.batch_tracking {
  overflow: hidden;
}

.tracking_top {
  text-align: left;
}

.ad_notice_content {
  margin-top: 1rem;
  margin-bottom: 1rem;
  text-align: left;
}

.ad_notice_content .el-tag {
  font-size: 0.9rem;
}

.file_log_content {
  padding: 0.2rem;
  margin-left: 2rem;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/customer/Orderform.vue